export default __webpack_public_path__ + "static/media/Armbands of the Furious Swipe.0a5be400.jpg";